import React, { Component } from "react";
import isEmpty from "lodash/isEmpty";
import map from "lodash/map";
import { connect } from "react-redux";
import * as BrowseAndNevigateSearchAction from "../../pages/BrowseAndNavigate/BrowseAndNevigateSearch/actions";
import commonUtil from "../../utils/commonUtil";

@connect(
  (store) => ({
    headerFooterData: store.globalData.data || {},
    globalObject: store.globleObject,
  }),
  { ...BrowseAndNevigateSearchAction }
)
class NewFooterComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      accordion: {},
    };
  }

  toggleClass = (e, i) => {
    this.setState((prevState) => {
      const accordion = {};
      accordion[e] = !prevState.accordion[e];
      return { accordion };
    });
  };
  render() {
    return (
      <footer id="footer" className="">
        {/* <div className="o-container__footer">
          <div className="m-container__footerLinkSession">
            <a className="a-footer__linkSession" id="signInFooter test">
              Iniciar Sesión
            </a>
          </div>
        </div> */}

        <div className="o-container__footer items_links">
          <div className="m-footer_linksMain">
            {this.props.headerFooterData &&
              this.props.headerFooterData?.footerContent &&
              this.props.headerFooterData?.footerContent?.menu_items &&
              this.props.headerFooterData?.footerContent?.menu_items?.map(
                (eachItem) => {
                  return (
                    <ul
                      className={
                        "m-footer__links footer-dropdown m-footer__links_4_links"
                      }
                    >
                      <li className="a-footer__linksTitle">
                        <div
                          className="a-footer_linkOpen"
                          onClick={() => this.toggleClass("soporte")}
                        >
                          {eachItem?.label}{" "}
                          <span className="icon-flecha_gruesa_abajo"></span>
                        </div>
                      </li>
                      {eachItem?.items?.map((option) => {
                        return (
                          <li>
                            <a href={option.url} className="a-footer__link">
                              {option.label}
                            </a>
                          </li>
                        );
                      })}
                    </ul>
                  );
                }
              )}
          </div>

          <div className="m-footer__links-contact">
            {/* <a
              className="a-footer__boletin"
              href="https://www.liverpool.com.mx/tienda/paginas/Boletin/boletin/"
            >
              Suscríbete a nuestro Newsletter
            </a> */}
            <div
              className={"footer-dropdown"}
              dangerouslySetInnerHTML={{
                __html:
                  this.props.headerFooterData &&
                  this.props.headerFooterData.footerContent &&
                  this.props.headerFooterData.footerContent.content,
              }}
            />
          </div>
        </div>

        <div className="o-container__footer items_links-social">
          <div className="m-footer__links">
            <a
              className="a-footer__link"
              href="https://www.liverpool.com.mx/tienda/home"
            >
              Comentarios y Sugerencias:{" "}
            </a>
            <a
              className="a-footer__link"
              href="mailto:atencion@liverpool.com.mx"
            >
              atencion@liverpool.com.mx
            </a>
          </div>

          <div className="m-footer__links --centerText">
            {this.props.headerFooterData.footerContent &&
              this.props.headerFooterData.footerContent.menu_links &&
              this.props.headerFooterData.footerContent.menu_links.map(
                (menuLink, index) => {
                  if (
                    this.props.headerFooterData.footerContent.menu_links
                      .length -
                      1 ==
                    index
                  ) {
                    return (
                      <React.Fragment>
                        <a
                          className="a-footer__link"
                          target="_blank"
                          rel="noreferrer"
                          href={menuLink.url}
                        >
                          {menuLink.label}
                        </a>
                      </React.Fragment>
                    );
                  } else {
                    return (
                      <React.Fragment>
                        <a
                          className="a-footer__link"
                          target="_blank"
                          rel="noreferrer"
                          href={menuLink.url}
                        >
                          {menuLink.label}
                        </a>
                        <span className="a-footer__slash">/</span>
                      </React.Fragment>
                    );
                  }
                }
              )}
          </div>

          <div className="m-footer__links --social">
            {this.props.headerFooterData &&
              this.props.headerFooterData.footerContent &&
              this.props.headerFooterData.footerContent.social_media &&
              this.props.headerFooterData.footerContent.social_media.map(
                (socialMedia, index) => {
                  return (
                    socialMedia.label !== "Profeco" &&
                    socialMedia.label !== "Distintivo" && (
                      <a
                        target="_blank"
                        rel="noreferrer"
                        href={socialMedia.url}
                        aria-label={`Liverpool - ${socialMedia.label}`}
                      >
                        <i
                          className={`icon-social-${socialMedia.label.toLowerCase()}`}
                        ></i>
                      </a>
                    )
                  );
                }
              )}
          </div>
        </div>

        <div className="o-container__footer items_links-rights">
          <p
            className="a-footer__misc"
            dangerouslySetInnerHTML={{
              __html:
                this.props.headerFooterData &&
                this.props.headerFooterData.footerContent &&
                this.props.headerFooterData.footerContent.extra_content,
            }}
          />
        </div>
      </footer>
    );
  }
}

export default NewFooterComponent;
